export enum DriveEvents {
  FileUploaded = 'drive.FileUploaded',
  FolderCreated = 'drive.folder.Created',
  DriveCreated = 'drive.drive.Created'
}
